<template>
  <div class="popular-container">
    <h4 class="popular-title">Our most popular offers</h4>

    <div class="four-cards-group">
      <b-card-group deck class="deck-cards">
        <b-card
          v-for="(product, index) in activeCards"
          :key="product.id"
          :title="product.productTitle"
          :img-src="product.cardImage"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow add-border-radius"
          id="productCard"
        >
          <b-card-text>
            {{ showPrice(index) }}
          </b-card-text>
          <b-card-text>
            {{ product.description }}
          </b-card-text>
          <div v-show="false">
            <b-form-rating
              v-model="rating"
              class="rating-box responsive-rating"
              readonly
              precision="2"
              no-border
              inline
            ></b-form-rating>
            <p class="mt-2" style="margin-top:0">( {{ reviewsNumber }} )</p>
          </div>
        </b-card>
      </b-card-group>
    </div>

    <!-- <div class="four-cards-group">
      <b-card-group deck>
        <b-card
          title="Product One"
          img-src="https://source.unsplash.com/random/300X300"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow add-border-radius"
        >
          <b-card-text>
            12.00 EUR
          </b-card-text>
          <div>
            <b-form-rating
              v-model="rating"
              class="rating-box responsive-rating"
              readonly
              precision="2"
              no-border
              inline
            ></b-form-rating>
            <p class="mt-2" style="margin-top:0">( {{ reviewsNumber }} )</p>
          </div>
        </b-card>

        <b-card
          title="Product Two"
          img-src="https://source.unsplash.com/user/wsanter"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow  add-border-radius"
        >
          <b-card-text>
            12.00 EUR
          </b-card-text>
          <div>
            <b-form-rating
              v-model="rating"
              class="rating-box"
              readonly
              precision="2"
              no-border
              inline
            ></b-form-rating>
            <p class="mt-2" style="margin-top:0">( {{ reviewsNumber }} )</p>
          </div>
        </b-card>

        <b-card
          title="Product Three"
          img-src="/img/logo.68852ff1.png"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow  add-border-radius"
        >
          <b-card-text>
            12.00 EUR
          </b-card-text>
          <div>
            <b-form-rating
              v-model="rating"
              class="rating-box"
              readonly
              precision="2"
              no-border
              inline
            ></b-form-rating>
            <p class="mt-2" style="margin-top:0">( {{ reviewsNumber }} )</p>
          </div>
        </b-card>

        <b-card
          title="Product Four"
          img-src="https://source.unsplash.com/random/300×300"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow  add-border-radius"
        >
          <b-card-text>
            12.00 EUR
          </b-card-text>
          <div>
            <b-form-rating
              v-model="rating"
              class="rating-box"
              readonly
              precision="2"
              no-border
              inline
            ></b-form-rating>
            <p class="mt-2" style="margin-top:0">( {{ reviewsNumber }} )</p>
          </div>
        </b-card>
      </b-card-group>
    </div> -->

    <!-- <div class="four-cards-group">
      <b-card-group deck>
        <b-card
          title="Product Five"
          img-src="https://source.unsplash.com/random/900×700/?person"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow  add-border-radius"
        >
          <b-card-text>
            12.00 EUR
          </b-card-text>
          <div>
            <b-form-rating
              v-model="rating"
              class="rating-box"
              readonly
              precision="2"
              no-border
              inline
            ></b-form-rating>
            <p class="mt-2" style="margin-top:0">( {{ reviewsNumber }} )</p>
          </div>
        </b-card>

        <b-card
          title="Product Six"
          img-src="/img/logo.68852ff1.png"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow  add-border-radius"
        >
          <b-card-text>
            12.00 EUR
          </b-card-text>
          <div>
            <b-form-rating
              v-model="rating"
              class="rating-box"
              readonly
              precision="2"
              no-border
              inline
            ></b-form-rating>
            <p class="mt-2" style="margin-top:0">( {{ reviewsNumber }} )</p>
          </div>
        </b-card>

        <b-card
          title="Product Seven"
          img-src="https://source.unsplash.com/random/200×200/?book"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow  add-border-radius"
        >
          <b-card-text>
            12.00 EUR
          </b-card-text>
          <div>
            <b-form-rating
              v-model="rating"
              class="rating-box"
              readonly
              precision="2"
              no-border
              inline
            ></b-form-rating>
            <p class="mt-2" style="margin-top:0">( {{ reviewsNumber }} )</p>
          </div>
        </b-card>

        <b-card
          title="Product Eight"
          img-src="/img/logo.68852ff1.png"
          img-alt="Personalised Gifts Image"
          img-top
          class="text-center shadow add-border-radius"
        >
          <b-card-text>
            12.00 EUR
          </b-card-text>
          <div>
            <b-form-rating
              v-model="rating"
              class="rating-box"
              readonly
              precision="2"
              no-border
              inline
            ></b-form-rating>
            <p class="mt-2" style="margin-top:0">( {{ reviewsNumber }} )</p>
          </div>
        </b-card>
      </b-card-group>
    </div> -->
    <div style="display: flex; justify-content: center; margin-bottom: 4rem;">
      <b-toast
        id="no-more-product-toast"
        static
        auto-hide-delay="7000"
        variant="secondary"
        no-close-button
      >
        No more products to show.
      </b-toast>
    </div>
    <!-- BUTTON -->
    <div class="button-see-more-box" v-if="false">
      <b-button
        pill
        variant="outline-dark"
        class="button-see-more"
        @click="seeMoreProducts"
        >See More</b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "PopularFormulasCards",
  components: {},
  data() {
    return {
      rating: 3.555,
      reviewsNumber: 288,
      cardsData: [
        {
          id: 1,
          productTitle: "Product One",
          description: "This is the Product One description",
          price: 12.0,
          cardImage: "/img/logo.68852ff1.png",
          showOnDeck: true,
        },
        {
          id: 2,
          productTitle: "Product Two",
          description: "This is the Product Two description",
          price: 22.0,
          cardImage: "/img/logo.68852ff1.png",
          showOnDeck: true,
        },
        {
          id: 3,
          productTitle: "Product Three",
          description: "This is the Product Three description",
          price: 32,
          cardImage: "/img/logo.68852ff1.png",
          showOnDeck: true,
        },
        {
          id: 4,
          productTitle: "Product Four",
          description: "This is the Product Four description",
          price: 42,
          cardImage: "/img/logo.68852ff1.png",
          showOnDeck: true,
        },
        {
          id: 5,
          productTitle: "Product Five",
          description: "This is the Product Five description",
          price: 52,
          cardImage: "/img/logo.68852ff1.png",
          showOnDeck: true,
        },
        {
          id: 6,
          productTitle: "Product Six",
          description: "This is the Product Six description",
          price: 62,
          cardImage: "/img/logo.68852ff1.png",
          showOnDeck: true,
        },
        {
          id: 7,
          productTitle: "Product Seven",
          description: "This is the Product Seven description",
          price: 72,
          cardImage: "/img/logo.68852ff1.png",
          showOnDeck: true,
        },
        {
          id: 8,
          productTitle: "Product Eight",
          description: "This is the Product Eight description",
          price: 82,
          cardImage: "/img/logo.68852ff1.png",
          showOnDeck: true,
        },
        // {
        //   id: 9,
        //   productTitle: "Product Nine",
        //   description: "This is the Product Nine description",
        //   price: 92,
        //   cardImage: "/img/logo.68852ff1.png",
        //   //cardImage: "https://source.unsplash.com/random",
        //   showOnDeck: true,
        // },
      ],
    };
  },
  computed: {
    activeCards: function() {
      return this.cardsData.filter(function(u) {
        return u.showOnDeck;
      });
    },
  },
  methods: {
    showPrice(index) {
      return this.cardsData[index].price.toFixed(2) + " EUR";
    },
    seeMoreProducts() {
      //check there is more product to be shown on deck
      const count = this.cardsData.reduce(
        (counter, { showOnDeck }) =>
          showOnDeck === false ? (counter += 1) : counter,
        0
      );
      if (count > 0) {
        //generate a subarray with all hidden cardsData
        //set their value to true
        // let i = 0;
        // const newArr = this.cardsData.map((object) => {
        //   if (object.showOnDeck === false && i < 4) {
        //     //change value of showOnDeck property
        //     return { ...object, showOnDeck: true };
        //   }
        //   return object;
        // });
        // console.log(newArr);
        // this.activeCards;
        // i++;
      } else {
        this.$bvToast.show("no-more-product-toast");
      }
    },
  },
};
</script>

<style scoped lang="scss">
$light-gray: #e7e7e7;

.popular-title {
  font-weight: 700;
  margin: 3rem 0;
}

.four-cards-group {
  //margin-bottom: 4rem;
}

.deck-cards {
  display: flex;
  justify-content: flex-start;
  margin: auto;
}

div.card {
  border: none;
  //display: inline-block;
}

.card-img-top {
  //background-color: $light-gray;
}

h4.card-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.add-border-radius {
  border-radius: 1rem;
  //margin-left: 0;
  //margin-right: 0;
  min-width: 209.5px;
  max-width: 209.5px;
  margin: 1rem 1.25rem;

  //object-fit: cover;

  img {
    border-radius: 1rem 1rem 0 0;
    background-color: $light-gray;
    height: 220px;
  }
}

.button-see-more-box {
  display: flex;
  justify-content: center;

  button {
    font-weight: 700;
    &:hover {
      background-color: black;
    }
  }
}

/* Row Container */
.row {
  display: flex;
  flex-wrap: wrap;
}

/* In order to create four equal columns */
.column {
  flex: 25%;
  padding: 20px;
}

/* two columns */
@media screen and (max-width: 992px) {
  .column {
    flex: 50%;
  }
}

/* One column */
@media screen and (max-width: 600px) {
  .row {
    flex-direction: column;
  }
}

@media screen and (min-width: 1025px) {
  .add-border-radius {
    //margin-right: 4rem;

    &:last-child {
      //margin-right: 0;
    }
  }
}

@media screen and (max-width: 768px) {
  .card-deck {
    margin-left: 0;
  }
}

@media screen and (max-width: 575px) {
  .four-cards-group {
    margin-bottom: 0;
  }

  .card-deck {
    text-align: -webkit-center;
  }

  .add-border-radius {
    margin-right: 1rem;
  }
}

@media screen and (max-width: 399px) {
  .card-deck {
    text-align: -webkit-center;
  }
}
</style>
